// extracted by css-extract-rspack-plugin
export default {"root":"root-yxh16_","toggler":"toggler-XKTXUy","day":"day-nK_kWA"};